import { useEffect, useState } from 'react';
import Select from 'react-select';
import { apiPrefix } from '../../config';
import { getAuthHeader } from '../../helpers/auth';
import { handleRequestError } from '../../helpers/requests';

const RegionSelect = ({ onChange }: { onChange: (e: any) => void }) => {
  const [regions, setRegions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchRegions = async () => {
    setLoading(true);
    const response = await fetch(apiPrefix + '/authority', {
      headers: await getAuthHeader(),
    });
    if (response.ok) {
      const data = await response.json();
      const allRegions: string[] = data.councils.map((c: { region: string }) => c.region);
      const uniqueRegions = allRegions
        .filter((r, i) => allRegions.indexOf(r) === i)
        .sort((a, b) => a.trim().localeCompare(b.trim()));
      setRegions(uniqueRegions);
    } else handleRequestError(response);
    setLoading(false);
  };

  const handleChange = (e: any) => {
    if (e == null) {
      onChange({ value: null });
      return;
    }
    onChange({ value: e.value });
  };

  useEffect(() => {
    fetchRegions();
  }, []);

  return (
    <Select
      placeholder={loading ? 'Loading regions' : 'Select Region'}
      isClearable
      isLoading={loading}
      onChange={handleChange}
      options={regions.map((r) => ({ value: r, label: r }))}
    />
  );
};

export default RegionSelect;
